import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { CButton, CContainer, CRow, CCol, CCard, CCardBody, CSpinner } from '@coreui/react'
import { useSelector } from 'react-redux'
import { updateTos } from '../utils/tosUtils'
import fusionOidc from '../fusionOidc'

const TosAgreement = ({ user, onAgree }) => {
  const token = useSelector((state) => state.token)
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleProceed = async () => {
    if (isSubmitting) return

    try {
      setIsSubmitting(true)

      // console.log('=== TOS Agreement Debug Info ===')
      // console.log('User object:', user)
      // console.log('Token object:', token)

      // Decode and log token payload for debugging
      /*
      if (token?.access_token) {
        try {
          const tokenPayload = JSON.parse(atob(token.id_token.split('.')[1]))
          console.log('ID token payload:', tokenPayload)
          console.log('Token scopes:', tokenPayload.scope)
        } catch (e) {
          console.warn('Could not decode access token:', e)
        }
      }
      */

      // Get user's IP address (for tracking purposes)
      let ipAddress = 'unknown'
      try {
        const response = await fetch('https://api.ipify.org?format=json')
        const data = await response.json()
        ipAddress = data.ip
      } catch (error) {
        console.warn('Could not fetch IP address:', error)
      }

      // Record TOS agreement
      const agreementData = {
        time: Date.now(),
        ipAddress: ipAddress,
      }

      const userId = user.sub || user.id || 'unknown'
      // console.log('Using userId for metadata:', userId)

      await updateTos(userId, token.access_token, agreementData)

      // Refresh user data to get updated metadata
      await fusionOidc.doUser()
      // console.log('TOS agreement stored and user data refreshed')

      // Call the onAgree callback if provided
      if (onAgree) {
        onAgree(agreementData)
      }
    } catch (error) {
      console.error('Error recording TOS agreement:', error)
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <div
      className="min-vh-100 bg-light d-flex align-items-center justify-content-center"
      style={{ padding: '20px' }}
    >
      <CContainer>
        <CRow className="justify-content-center">
          <CCol md={8} lg={6}>
            <CCard>
              <CCardBody className="p-5">
                <div className="text-center mb-4">
                  <h2>Terms of Service Agreement</h2>
                </div>
                <div className="mb-4" style={{ fontSize: '16px', lineHeight: '1.6' }}>
                  <p>
                    By accessing FusionHub and the security services, available at no additional
                    charge, user acknowledges that user has read{' '}
                    <a
                      href="/tos.pdf"
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#0066cc', textDecoration: 'underline' }}
                    >
                      this agreement
                    </a>
                    , understands it, and agrees to be bound by its terms and conditions. Fusion
                    will deliver security services including, but not limited to,{' '}
                    <strong>phishing simulation and network footprint identification</strong>, with
                    all data, reports, and results provided under the relevant sections of your
                    FusionHub.
                  </p>
                  <p>If you do not agree to these terms, please do not proceed.</p>
                </div>
                <div className="text-center">
                  <CButton
                    color="primary"
                    size="lg"
                    onClick={handleProceed}
                    disabled={isSubmitting}
                    style={{ minWidth: '150px' }}
                  >
                    {isSubmitting ? (
                      <>
                        <CSpinner size="sm" className="me-2" />
                        Processing...
                      </>
                    ) : (
                      'Proceed'
                    )}
                  </CButton>
                </div>
              </CCardBody>
            </CCard>
          </CCol>
        </CRow>
      </CContainer>
    </div>
  )
}

TosAgreement.propTypes = {
  user: PropTypes.shape({
    sub: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  onAgree: PropTypes.func,
}

export default TosAgreement
